export const BE_APPTENTIVE_LINKS = {
  production: 'be.apptentive.com',
  staging: 'be.staging.apptentive.com',
  development: 'be.shared-dev.apptentive.com',
};
